import { Container } from "./styled/Container";
import { MDBContainer } from "mdbreact";

export const AcceptCookiesPresenter = ({ hide, remove, actionHandler }) => !remove ? <Container hide={hide} >
	<MDBContainer>
		<p>Este site utiliza cookies de terceiros para analisar o tráfego e a navegação dentro do site.</p>
		<button onClick={actionHandler}>Entendido!</button>
	</MDBContainer>
</Container> : null
